export const FETCH_SERVICES_DELETION_LOGS_REQUEST = "FETCH_SERVICES_DELETION_LOGS_REQUEST";
export const FETCH_SERVICES_DELETION_LOGS_SUCCESS = "FETCH_SERVICES_DELETION_LOGS_SUCCESS";
export const FETCH_SERVICES_DELETION_LOGS_FAILURE = "FETCH_SERVICES_DELETION_LOGS_FAILURE";